import React, { useEffect, useState, useRef, useContext } from "react";
import { Input } from "design-react-kit";
import { useLocation } from "react-router-dom";
import Repo from "../../Utility/Repo";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import { TokenContext } from "../../Components/TokenContext";
import Loader from "../../Components/Loader";
import ListPaymentsOperator from "../../Components/ListPaymentsOperator";
import Select  from "../../Components/Select";


function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function ListPaymemtsStatus(props) {
  const apiToken = useContext(TokenContext);
  const [paymentsTemp, setPaymentsTemp] = useState();
  const [payments, setPayments] = useState();
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState({
    name: null,
    chkNoSendMail: null,
    announcementId:null
  });
  const [nomeBando,setNomeBando] = useState('');


  useEffect(() => {
    console.log("getListPaymentFilterOperator"); 
    setLoading(false);
    if (apiToken) {
        Repo.getListPaymentFilterOperator(apiToken,filter)
          .then((response) => {
            if (response.status == 200) {
                setLoading(true);
              setPaymentsTemp(response.data);
            }
          })
          .catch((error) => {
            setLoading(true);
            console.log(error);
          }); 
    }
  }, []);


  const [announcementId, setAnnouncementId] = useState('');
  const [announcementOptions, setAnnouncementOptions] = useState([]); 

  useEffect(() => {
    console.log("fetchAnnouncements"); 
  const fetchAnnouncements = async () => {
    console.log("fetchAnnouncements"); 
    setLoading(false); // Inizia il caricamento
    try {
      const response = await Repo.getAnnouncementsOperator(apiToken);
      if (response.status === 200) {
        const options = response.data.map(announcement => ({
          value: announcement.id,
          label: announcement.name
        }));
        console.log("Opzioni Annunci: ", options); // Aggiungi log per verificare
        setAnnouncementOptions(options);
      } else {
        throw new Error('Errore nel recupero dei dati'); // Gestisci errori di stato
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(true); // Termina il caricamento
    }
  };

  fetchAnnouncements();
}, [apiToken]);


const handleChange = (selectedOption) => {
    // Aggiorna solo l'announcementId nel filtro
    setFilter(prevFilter => ({
      ...prevFilter,
      announcementId: selectedOption ? selectedOption.value : null
    }));

    setNomeBando(selectedOption.label);
  };




  const sendFilter = () => {
    setLoading(false);
    console.log("Filtro da inviare:", filter); // Log del filtro
    Repo.getListPaymentFilterOperator(apiToken, filter)
      .then((response) => {
        setPaymentsTemp(response.data);
        setLoading(true);
      })
      .catch((error) => {
        console.log(error);
        setLoading(true);
      });
  };

  const ricalcolaPosizioniDebitorie = () => {
    if (window.confirm("Sei sicuro di voler procedere con il ricalcolo delle posizioni debitorie?")) {
      Repo.postRiceviPosizioniDebitorie(apiToken)
        .then((response) => {
          // Gestisci la risposta qui
          console.log("Operazione eseguita con successo", response);
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      console.log("Operazione annullata");
    }
  };





    const [isUpdating, setIsUpdating] = useState(false);
  
    useEffect(() => {
      // Funzione che controlla lo stato di aggiornamento
      const checkStatus = () => {
        setIsUpdating(true);
        Repo.getImportStato(apiToken)
          .then((data) => {
            setIsUpdating(data.IsUpdating);
          })
          .catch((error) => {
            setIsUpdating(false); // Imposta a false in caso di errore
            console.log("Errore durante il controllo dello stato:", error);
          });
      };
  
      // Imposta il polling ogni 5 secondi
      const interval = setInterval(checkStatus, 10000);
  
      // Cleanup: ferma il polling quando il componente viene dismesso
      return () => clearInterval(interval);
    }, []);
  






  return (
    <>
      <h1>Lista pagamenti</h1>
      <div className="row">
      <div className="clearfix col-lg-8 py-lg-2">
        <p>Tutti i pagamenti ancora non effettuati o non ancora registrati sul sistema</p>
      </div>
      <div className="clearfix col-lg-4 py-lg-2 text-right">
      <button type="button" 
              className="btn btn-warning m-2"
              onClick={ricalcolaPosizioniDebitorie} disabled={isUpdating} // Disabilita il pulsante mentre l'importazione è in corso
              >
                {isUpdating ? <>Importazione in corso...</> : <>Sincronizza</>}
              </button>
        </div>
      </div>

      {/*Inizo cerca*/}


      {/*Inizo cerca*/}
      <div className="mt-3 shadow-sm p-3 mb-5 bg-white rounded">
        <div className="row">
          <div className="form-group col-4">
            <Input
              id="name"
              required
              label="Ricerca nel titolo"
              type="text"
              name="name"
              onChange={(e) => setFilter({ ...filter, name: e.target.value })}
            />
          </div>

          <div className="form-group col-4 text-center">
            <div className="form-check">
              <input
                id="chkNoSendMail"
                type="checkbox"
                checked={filter.chkNoSendMail}
                onChange={(e) =>
                  setFilter({ ...filter, chkNoSendMail: e.target.checked })
                }
              />
              <label htmlFor="chkNoSendMail">Email non inviata</label>
            </div>
          </div>

         


          <div className="form-group col-4">
        <Select
          aria-label="Record"
          defaultMenuIsOpen={false}
          required
          icon={false}
          label="Ciao"
          name="announcementsSelect"
          id="announcementsSelect"
          options={announcementOptions}
          onChange={handleChange}
          value={announcementOptions.find(option => option.value === filter.announcementId) || null} // Verifica se esiste
          placeholder="Seleziona un bando"
        />
      </div>

          <div className="form-group col-12 text-right">
            <button type="button" className="btn btn-outline-secondary m-2">
              Annulla
            </button>

            <button
              type="button"
              className="btn btn-outline-primary"
              onClick={sendFilter}
            >
              Cerca
            </button>
          </div>

        </div>
      </div>
      {/*Fine cerca*/}



      {paymentsTemp && paymentsTemp.length > 0 ? (
        <ListPaymentsOperator
          payments={payments}
          paymentsTemp={paymentsTemp}
          setPayments={setPayments}
          fiscalCode={true}
          goBack={true}
          nomeBando={nomeBando}
        />


        
      ) : (
        <>
          <div className="alert alert-warning" role="alert">
            <strong>Attenzione! </strong> Non ci sono pagamenti!
          </div>
        </>
      )}

      {!loading && <Loader></Loader>}
    </>
  );
}


export default ListPaymemtsStatus;
